import type { TicketStatus } from '@core/Areas/AccountActivity/types'
import type { FollowMeShareTicket } from '@core/Areas/FollowMe/types'
import { getTicketStatus } from '@core/Areas/AccountActivity/Components/Ticket/helpers'

export const getBetLoopTicketStatus = (ticket: FollowMeShareTicket): TicketStatus => {
  const ticketStatus: TicketStatus =
    getTicketStatus(ticket, ticket.status === 'Pending' ? 'pending' : null) || 'Pending'

  let forceStatusOverride: TicketStatus | null = null

  if (ticketStatus === 'Won' && isMoneyBackRefund(ticket)) {
    forceStatusOverride = 'NoPayout'
  }

  return forceStatusOverride || ticketStatus
}

// =============
// Local Helpers
// =============

const isMoneyBackRefund = (ticket: FollowMeShareTicket) => {
  if (
    !ticket.specialInformation ||
    !ticket.specialInformation.length ||
    !ticket.specialInformation.some(x => x.specialTypeCode === 'MB')
  ) {
    return false
  }

  return ticket.payValue > 0 && ticket.payValue == ticket.investment.total
}
